import React from 'react';
import { Field, initialize, reduxForm } from 'redux-form';
import { useTranslation } from 'react-i18next';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { get } from 'lodash';

import { ColorPicker } from 'components/ColorPicker';
import { api } from 'utils/api';
import { changeWebsite } from 'actions';
import { websiteSelector } from 'selectors';
import { Form } from 'components/Form';
import { isColor } from 'utils/formValidators';
import { initialSassValuesSelector, nextCustomStylesSelector } from '../selectors';

const formName = 'DesignFooter';

export function Footer(props) {
  const { t } = useTranslation();

  return (
    <Form {...props} formTitle="design.footer.title">
      <Field
        name="$footerBgColor"
        title={t('design.footer.footerBgColor.title')}
        inputMaxWidthPx={200}
        component={ColorPicker}
        validate={[isColor]}
      />

      <Field
        name="$footerTextColor"
        title={t('design.footer.footerTextColor.title')}
        inputMaxWidthPx={200}
        component={ColorPicker}
        validate={[isColor]}
      />

      <Field
        name="$footerLinkColor"
        title={t('design.footer.footerLinkColor.title')}
        inputMaxWidthPx={200}
        component={ColorPicker}
        validate={[isColor]}
      />

      <Field
        name="$footerLinkHoverColor"
        title={t('design.footer.footerLinkHoverColor.title')}
        inputMaxWidthPx={200}
        component={ColorPicker}
        validate={[isColor]}
      />
    </Form>
  );
}

const getInitialValuesSelector = (state) =>
  initialSassValuesSelector(state, {
    pickBy: ['$footerBgColor', '$footerTextColor', '$footerLinkColor', '$footerLinkHoverColor'],
  });

const updateWebsite = (id) => (dispatch, getState) => (formValues) => {
  const customStyles = nextCustomStylesSelector(getState(), { formValues });

  return api
    .patch(`/websites/${id}`, {
      customStyles,
    })
    .then((payload) => {
      dispatch(changeWebsite(payload));
      dispatch(initialize(formName, getInitialValuesSelector(getState())));
    });
};

export const FooterDecorated = compose(
  connect(
    (state) => ({
      website: websiteSelector(state),
      initialValues: getInitialValuesSelector(state),
      formName,
    }),
    {
      updateWebsite,
    },
    (stateProps, dispatchProps) => {
      const websiteId = get(stateProps.website, 'id');

      return {
        formName,
        initialValues: stateProps.initialValues,
        onSubmit: dispatchProps.updateWebsite(websiteId),
      };
    }
  ),
  reduxForm({
    form: formName,
    enableReinitialize: true,
  })
)(Footer);
